import { render, staticRenderFns } from "./shop-view.vue?vue&type=template&id=1e371b22&scoped=true"
import script from "./shop-view.vue?vue&type=script&lang=js"
export * from "./shop-view.vue?vue&type=script&lang=js"
import style0 from "./shop-view.vue?vue&type=style&index=0&id=1e371b22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e371b22",
  null
  
)

export default component.exports